<template>
  <el-container class="is-vertical d-block-xs">
    <el-container class="relative column">
      <div v-if="myDemos.length" class="headings no-shrink" style="text-align:center;color:#fff">
        <div style="height: 50px" class="hidden-xs-only"></div>
        <!-- <h2 style="font-size: 48px;margin: 10px 0;">Library</h2> -->
        <h1 class="flex-center" style="text-align: center; font-size: 50px;margin:10px 0; "><img src="/static/cooboicon5.svg" alt="" style="margin: 0 20px 0 0; width: 80px">LIBRARY</h1>
        <div class="container800">
          <div class="flex-center no-shrink">
            <p style="color:#fff;display:block;font-size: 21px;">Coobo is an editor to hyper accelerate the creation of rich learning experiences with deep analytics to build clear attribution between learning and outcomes. At the same time, our library of assets covers 75% of most curriculums for 3D assets. We also have worked with some of the best names in edtech for content creation eg Nearpod, Google, Pearson and Houghton Mifflin Harcourt.</p>
          </div>
        </div>
        <!-- <div class="flex-center no-shrink">
          <a href="https://docs.google.com/document/d/1B7weBMu4ud4fPbrpy4f4zLcSmbXnLuHgcT8PYJfux1Y/edit" class="btn-main shadowfloat">Details on curriculum coverage</a>
        </div> -->
      </div>
      <library-items v-if="myDemos.length" :items="myDemos" v-on:delete-item="deleteTour"></library-items>
    </el-container>
  </el-container>
</template>

<script>
  import LibraryItems from "../components/library-items.vue"

  export default {
    name: 'SecretLibrary',
    components: {
      LibraryItems
    },
    data () {
      return {
        myDemos: [
   {
      "_id":"5c2ff6720ff75549015e5493",
      "title":"ISS",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":"A demo tour made by Coobo to showcase some of the features of our learning platform.",
      "thumb":null,
      "slideQuizes":{
         "0":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":0,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         },
         "1":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":1,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         }
      },
      "createdAt":"2019-01-05T00:12:34.915Z",
      "updatedAt":"2019-03-23T20:09:26.773Z",
      "__v":0,
      "owner":"5b3fa3d7bfe27a76152292b2",
      "featured":false,
      "has_quiz":false,
      "id":"5c2ff6720ff75549015e5493",
      "keywords":null,
      "textContent":"THE FIRST FIFTEEN YEARS﻿ INTERNATIONAL SPACE STATION The ISS is a space station, or a habitable artificial satellite, in low Earth orbit. Its first component launched into orbit in 1998 and the last pressurized module was fitted in 2011. The station is expected to be used until 2030. SIZE The International Space Station is about the size of an American football field. Astronauts and cosmonauts have spent in total more than 1000 hours working outside the station. Approximately seven tons of supplies support a crew of three for about six months. COMPONENTS COLUMBUS KIBO HARMONY DESTINY UNITY NAUKA ZVEZDA ZARYA More than 1500 specific investigations have been performed on the ISS in the microgravity and low-earth orbit research laboratory. Experiments were conducted in human research, life sciences, physical sciences, earth sciences, astrophysics and technology research. Did you know? The ISS travels the equivalent distance to the moon and back in about a day. A GLOBAL PROGRAM ISS is a collaboration between the United States, Russia,  Canada, Japan, and several countries in Europe. The spaceport can dock a variety of international spacecraft: RUSSIA (Soyuz & Progress), U.S.A. (Space Shuttle, Dragon, Cygnus), JAPAN (HTV), EUROPE (ATV).﻿ SPACEPORT CONSTRUCTION Development and assembly of the station continues, with components scheduled for launch in 2018 and 2019. The ISS is the largest human-made body in low Earth orbit and can often be seen with the naked eye from Earth. The ISS consists of pressurized modules, external trusses, solar arrays, and other components. Explore the 3D model by spinning it around! The station is suited for the testing of spacecraft systems and equipment required for missions to the Moon and Mars.  ",
      "slideCount":16,
      "labelsCount":5,
      "quizCount":2,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c18206475f26607356adf71",
      "title":"Aedes Aegipty",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2018-12-17T22:17:08.228Z",
      "updatedAt":"2019-02-20T22:46:58.511Z",
      "__v":0,
      "owner":"5b3fa3d7bfe27a76152292b2",
      "keywords":"Mosquito",
      "textContent":"Class: InsectaOrder: DipteraSuperfamily: CulicoideaFamily: Culicidae Aedes Aegypti is the main carrier for dengue, chikungunya and zika viruses.﻿ ﻿MOSQUITO LOCATION Aedes Aegypti are found throughout the Americas, except in Canada and continental Chile. ADAPTATION It’s well adapted to human settlements, living in and around homes HABITS It bites primarily early in the morning and at sunset, but also at other times of the day BITE It sucks blood every three or four days or sometimes more frequently, irritating bites are due to an immune response from the binding of IgG and IgE antibodies to antigens in the mosquito's saliva. REPRODUCTION An egg can develop into a larva, pupa and adult within 7 to 10 days and an adult mosquito can live 4 to 6 weeks. A female Aedes can lay around 400 eggs during her lifetime, and eggs can resist drought and survive for up to a year ",
      "id":"5c18206475f26607356adf71",
      "slideCount":8,
      "labelsCount":1,
      "quizCount":1,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c32d47f0ff75549015e5496",
      "title":"Animal Cell",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":"A demo tour made by Coobo to showcase some of the features of our learning platform.",
      "views":0,
      "owner":"5b3fa3d7bfe27a76152292b2",
      "createdAt":"2019-01-07T04:24:31.359Z",
      "updatedAt":"2019-03-23T20:09:42.497Z",
      "__v":0,
      "slideQuizes":{

      },
      "thumb":null,
      "id":"5c32d47f0ff75549015e5496",
      "featured":false,
      "keywords":null,
      "textContent":"ANIMAL CELL Animal cells are the basic unit of life in organisms of the kingdom Animalia. They are eukaryotic cells, meaning that they have a true nucleus and specialized structures called organelles that carry out different functions. Cells carry out all the processes of the body, including producing and storing energy, and making proteins, which are molecules that have roles in metabolism, DNA replication, and transportation of other molecules.  Functions of Animal Cells Cells are highly specialized to carry out specific tasks. For example, the heart has cardiac muscle cells that beat in unison, and digestive tract cells have cilia, finger-like projections that increase surface area for the absorption of nutrients during digestion.  Functions of Animal Cells Animal Cell Structure The nucleus contains a cell’s deoxyribonucleic acid (DNA), its genetic material. DNA contains instructions for making proteins, which controls all of the body’s activities. In the nucleus, DNA is tightly winded around histones, which are proteins, to form structures called chromosomes.  ",
      "slideCount":6,
      "labelsCount":6,
      "quizCount":1,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c07086f2d261c43ef9bfbd2",
      "title":"Gravity rotation orbit",
      "categories":[
         {
            "_id":"5b2ea1ebd8d14668ba1c5ce5",
            "name":"Curricular Content",
            "slug":"curricular-content",
            "enabled":true,
            "createdAt":"2018-06-23T19:39:23.139Z",
            "updatedAt":"2018-06-27T13:19:22.813Z",
            "__v":0,
            "id":"5b2ea1ebd8d14668ba1c5ce5",
            "only_google":true
         },
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":"",
      "views":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "createdAt":"2018-12-04T23:06:23.576Z",
      "updatedAt":"2019-02-18T08:13:48.499Z",
      "__v":0,
      "slideQuizes":{

      },
      "thumb":null,
      "keywords":null,
      "textContent":"The Sun’s mass exerts gravitational force which compels Earth to orbit around it.  Earth is 149.6 million miles from the Sun.  The Sun is so large and has so much mass that even Pluto orbits around it, despite being 3.67 billion miles away. The Sun is the largest object in our Solar System 1.3 million Earths could fit inside the Sun. The Sun makes up over 99.86% of our Solar Systems total mass.Most of this mass is in the form of hydrogen.  The Sun is the largest object in our Solar System 1.3 million Earths could fit inside the Sun. The Sun makes up over 99.86% of our Solar Systems total mass. Most of this mass is in the form of hydrogen. The mass of the Sun affects everything in the Solar System. The Sun exerts massive gravitational pull, which causes all the planets in the Solar System to orbit around it.  Earth, along with seven other planets orbit around a small star we call the Sun. The Sun is the largest object in our Solar System.1.3 million Earths could fit inside the Sun.  The Sun makes up over 99.86% of our Solar Systems total mass. Most of this mass is in the form of hydrogen. The Sun’s mass exerts gravitational force which compels Earth to orbit around it.  Earth is 149.6 million miles from the Sun.  The Sun is so large and has so much mass that even Pluto orbits around it, despite being 3.67 billion miles away. Earth is not destined to get pulled into the Sun. While the Sun has a strong gravitational pull the Earth has its own velocity through space. It is similar to swinging a ball tied to a rope around your head. While the rope holds the ball in orbit (like the Sun does with Earth), the ball also has its own sideways motion, preventing it from being pulled in. The Sun’s mass exerts gravitational force which compels Earth to orbit around it.  Earth is 149.6 million miles from the Sun.  The Sun is so large and has so much mass that even Pluto orbits around it, despite being 3.67 billion miles away. Earth is not destined to get pulled into the Sun. While the Sun has a strong gravitational pull the Earth has its own velocity through space. It is similar to swinging a ball tied to a rope around your head. While the rope holds the ball in orbit (like the Sun does with Earth), the ball also has its own sideways motion, preventing it from being pulled in. The Earth formed out of spinning clouds of gas. Further collisions with rocks and asteroids kept the planet spinning on its own axis. The Sun’s mass exerts gravitational force which compels Earth to orbit around it.  Earth is 149.6 million miles from the Sun.  The Sun is so large and has so much mass that even Pluto orbits around it, despite being 3.67 billion miles away. Earth is not destined to get pulled into the Sun. While the Sun has a strong gravitational pull the Earth has its own velocity through space. It is similar to swinging a ball tied to a rope around your head. While the rope holds the ball in orbit (like the Sun does with Earth), the ball also has its own sideways motion, preventing it from being pulled in. The Earth formed out of spinning clouds of gas. Further collisions with rocks and asteroids kept the planet spinning on its own axis. The Earth rotates on its own axis over a 24 hour period.  The Moon rotates on its own axis. It takes the Earth approximately 365 days to complete one orbit around the Sun. The Sun’s mass exerts gravitational force which compels Earth to orbit around it.  Earth is 149.6 million miles from the Sun.  The Sun is so large and has so much mass that even Pluto orbits around it, despite being 3.67 billion miles away. Earth is not destined to get pulled into the Sun. While the Sun has a strong gravitational pull the Earth has its own velocity through space. It is similar to swinging a ball tied to a rope around your head. While the rope holds the ball in orbit (like the Sun does with Earth), the ball also has its own sideways motion, preventing it from being pulled in. The Earth formed out of spinning clouds of gas. Further collisions with rocks and asteroids kept the planet spinning on its own axis. The Earth rotates on its own axis over a 24 hour period.  The Moon rotates on its own axis.\n It takes the Earth approximately 365 days to complete one orbit around the Sun.  Smaller objects spiral inwards towards the massive object, like a marble rolling around the edge of a trampoline. Massive objects warp the fabric of the universe itself and cause a distortion in space–time, like a bowling bowl sitting on a trampoline. ",
      "id":"5c07086f2d261c43ef9bfbd2",
      "slideCount":9,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c07c3002d261c43ef9bfbe2",
      "title":"Mass vs weight",
      "categories":[
         {
            "_id":"5b2ea1ebd8d14668ba1c5ce5",
            "name":"Curricular Content",
            "slug":"curricular-content",
            "enabled":true,
            "createdAt":"2018-06-23T19:39:23.139Z",
            "updatedAt":"2018-06-27T13:19:22.813Z",
            "__v":0,
            "id":"5b2ea1ebd8d14668ba1c5ce5",
            "only_google":true
         },
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":"",
      "views":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "createdAt":"2018-12-05T12:22:24.767Z",
      "updatedAt":"2019-02-18T08:09:10.559Z",
      "__v":0,
      "slideQuizes":{

      },
      "thumb":null,
      "keywords":null,
      "textContent":"The Sun is the largest object in our Solar System 1.3 million Earths could fit inside the Sun. The Sun makes up over 99.86% of our Solar Systems total mass. This means that the Sun contains 99.86% of all the matter in the Solar System The mass of the Sun affects everything in the Solar System. It exerts massive gravitational pull, which causes all the planets in the Solar System to orbit around it.  Mars is 2,460 miles in radius The rhinoceros would weigh 1,885 pounds if it stood on the surface of Mars. Mars is 53% size of Earth. It contains less matter than Earth. Jupiter is the largest planet in our Solar System and is 43,441 miles in radius. Due to its enormous gravitational force our rhinoceros would weigh 12,640 pounds if it could somehow stand on the gaseous planet. Jupiter is 1,120% larger than Earth. It contains approximately 2.5 times more mass than all the other planets in the Solar System combined. The rhinoceros would weigh 5,320 pounds if it visited Saturn. As Saturn is a gaseous planet its surface gravitational field is not much more than Earth’s, despite it being much bigger. Saturn is 36,184 miles in radius. Its rings stretch out across 175,000 miles. Saturn is 945% larger than Earth.  Uranus has a radius of 15,759 miles. The rhinoceros would weigh 4,445 pounds if it got to the surface of Uranus. Like Saturn, its surface gravitational field is weaker as it is a gas planet Uranus is 400% larger than Earth. \nMuch of its mass comes from a dense liquid mixture of ammonia, water and methane.\n Neptune has a radius of 15,299 miles.\n The rhinoceros would weigh 5,625 pounds if he could somehow stand on the gaseous planet.  Neptune is 388% larger than Earth.  Due to the Sun’s large amount of mass and strong gravitational force our 5,000 pound rhinoceros will weigh: 135,360 pounds 135,360 pounds Neptune has a radius of 15,299 miles.\n The rhinoceros would weigh 5,625 pounds if he could somehow stand on the gaseous planet.  Neptune is 388% larger than Earth.  Everything contains mass. Mass is the amount of matter an object or organism contains.\n Mass does not change when an object’s location changes.  No matter which planet the rhinoceros travels to the amount of mass it has will remain the same. Due to the Sun’s large amount of mass and strong gravitational force our 5,000 pound rhinoceros will weigh: 135,360 pounds 135,360 pounds Neptune has a radius of 15,299 miles.\n The rhinoceros would weigh 5,625 pounds if he could somehow stand on the gaseous planet.  Neptune is 388% larger than Earth.  Everything contains mass. Mass is the amount of matter an object or organism contains.\n Mass does not change when an object’s location changes.  No matter which planet the rhinoceros travels to the amount of mass it has will remain the same. Weight is the force exerted by a body when it is in a gravitational field. Weight changes depending on the strength of the gravitational field it is sitting in. The rhinoceros weight will change if it travelled to different planets as each planet has its own gravitational field. On Earth this rhino weighs 5,000 pounds. The mass of the Sun affects everything in the Solar System. It exerts massive gravitational pull, which causes all the planets in the Solar System to orbit around it.  The mass of the Sun affects everything in the Solar System. It exerts massive gravitational pull, which causes all the planets in the Solar System to orbit around it.  1.3 million Earths could fit inside the Sun. The Sun is the largest object in our Solar System The Sun makes up over 99.86% of our Solar Systems total mass. This means that the Sun contains 99.86% of all the matter in the Solar System ",
      "id":"5c07c3002d261c43ef9bfbe2",
      "slideCount":14,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c14051ccacc0e23c5903dbe",
      "title":"Earth layers ",
      "categories":[
         {
            "_id":"5b2ea1ebd8d14668ba1c5ce5",
            "name":"Curricular Content",
            "slug":"curricular-content",
            "enabled":true,
            "createdAt":"2018-06-23T19:39:23.139Z",
            "updatedAt":"2018-06-27T13:19:22.813Z",
            "__v":0,
            "id":"5b2ea1ebd8d14668ba1c5ce5",
            "only_google":true
         },
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":"",
      "views":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "only_google":true,
      "createdAt":"2018-12-14T19:31:40.939Z",
      "updatedAt":"2019-02-18T07:11:51.703Z",
      "__v":0,
      "slideQuizes":{

      },
      "thumb":null,
      "keywords":null,
      "textContent":"Earth is a rocky planet which is composed of several layers. The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer. Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The continental crust is between five miles to 43 miles deep. Igneous rocks are formerly molten magma that have cooled. Metamorphic rocks are rocks that began as one type of rock which has changed into another due to extreme heat or pressure. Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The continental crust is between five miles to 43 miles deep. Igneous rocks are formerly molten magma that have cooled. Metamorphic rocks are rocks that began as one type of rock which has changed into another due to extreme heat or pressure. Continental crust makes up less than 0.4% of Earth’s total volume. Continental crust consists of hard rock. These rocks become hard after being exposed to cooler temperatures and oxygen on and near the surface. The continental crust is too buoyant to sink back into the hot mantle. Due to this the continental crust is extremely old, around two billion years old.  Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text The upper mantle lies underneath the Earth’s crust, up to 420 miles under the surface. The upper mantle is made of a mix of solid and liquid rock Parts of the upper mantle closer to the surface consists of more solid rock. Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The upper mantle lies underneath the Earth’s crust, up to 420 miles under the surface. The upper mantle is made of a mix of solid and liquid rock Parts of the upper mantle closer to the surface consists of more solid rock. The average temperature of this layer is over 5400℉ The lower mantle is a solid layer of rock that lies at between 420 and 1790 miles below the surface. The rock is certainly hot enough to become liquid, however the immense pressure keeps the rock solid.\n Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The upper mantle lies underneath the Earth’s crust, up to 420 miles under the surface. The upper mantle is made of a mix of solid and liquid rock Parts of the upper mantle closer to the surface consists of more solid rock. The average temperature of this layer is over 5400℉ The lower mantle is a solid layer of rock that lies at between 420 and 1790 miles below the surface. The rock is certainly hot enough to become liquid, however the immense pressure keeps the rock solid.\n The Earth’s outer core is located over 3,200 miles beneath the surface. The outer core is the only liquid layer within Earth. It’s average temperature sits at over 9,000℉ Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The upper mantle lies underneath the Earth’s crust, up to 420 miles under the surface. The upper mantle is made of a mix of solid and liquid rock Parts of the upper mantle closer to the surface consists of more solid rock. The average temperature of this layer is over 5400℉ The lower mantle is a solid layer of rock that lies at between 420 and 1790 miles below the surface. The rock is certainly hot enough to become liquid, however the immense pressure keeps the rock solid.\n The Earth’s outer core is located over 3,200 miles beneath the surface. The outer core is the only liquid layer within Earth. It’s average temperature sits at over 9,000℉ The outer core is made up of molten iron and nickel.  The constant flow of the outer core is responsible for Earth’s magnetic field. Click here to find out more about Earth’s magnetic field  The inner core lies at the very center of Earth. \n The inner core remains solid due to the massive amount of pressure surrounding it. Consisting of iron and some nickel, Earth’s inner core sits at an average temperature of 9,900℉ Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The upper mantle lies underneath the Earth’s crust, up to 420 miles under the surface. The upper mantle is made of a mix of solid and liquid rock Parts of the upper mantle closer to the surface consists of more solid rock. The average temperature of this layer is over 5400℉ The lower mantle is a solid layer of rock that lies at between 420 and 1790 miles below the surface. The rock is certainly hot enough to become liquid, however the immense pressure keeps the rock solid.\n The Earth’s outer core is located over 3,200 miles beneath the surface. The outer core is the only liquid layer within Earth. It’s average temperature sits at over 9,000℉ The outer core is made up of molten iron and nickel.  The constant flow of the outer core is responsible for Earth’s magnetic field. Click here to find out more about Earth’s magnetic field  The inner core lies at the very center of Earth. \n The inner core remains solid due to the massive amount of pressure surrounding it. Consisting of iron and some nickel, Earth’s inner core sits at an average temperature of 9,900℉ Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The part of the crust that makes up land is called continental crust.  Continental crust is primarily composed of sedimentary rocks, metamorphic rocks and granite.  Crust that lies beneath the ocean bed is called oceanic crust. Oceanic crust is primarily composed of basalt. The layer humans live on is called the Earth’s crust. The crust makes up the thinnest of the layers that makes up Earth.  The upper mantle lies underneath the Earth’s crust, up to 420 miles under the surface. The upper mantle is made of a mix of solid and liquid rock Parts of the upper mantle closer to the surface consists of more solid rock. The average temperature of this layer is over 5400℉ The lower mantle is a solid layer of rock that lies at between 420 and 1790 miles below the surface. The rock is certainly hot enough to become liquid, however the immense pressure keeps the rock solid.\n The Earth’s outer core is located over 3,200 miles beneath the surface. The outer core is the only liquid layer within Earth. It’s average temperature sits at over 9,000℉ The outer core is made up of molten iron and nickel.  The constant flow of the outer core is responsible for Earth’s magnetic field. Click here to find out more about Earth’s magnetic field  Earth is a rocky planet which is composed of several layers.  The deepest hole ever created by humans, the Exxon Z-44 Chayvo oil well, reaches over 40,000 feet deep. Humans would still need to dig another 60,000 feet to reach the bottom of the Earth’s outermost layer  If humans are unable to even dig through the Earth’s outermost layer, how do we know what’s inside? Earth’s crust (the first layer) constantly moves. Major movement such as earthquakes and volcanoes throw up material that was located deep inside other layers, allowing scientists to study them when they reach the surface.\n Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. Earth’s magnetic field protects the planet from harmful particles emitted from the Sun. The Earth spins on its own axis The movement of the hot, heavy, liquid metals creates powerful electrical currents. The outer core swirls in a westward direction. These electrical currents create a magnetic field that stretches into space, surrounding Earth.  Scientists also measure movement deep inside the Earth. Seismic waves travel at different speeds depending on whether it is travelling through liquid or solid rock. The inner core remains solid due to the massive amount of pressure surrounding it.\n The inner core lies at the very center of Earth. Consisting of iron and some nickel, Earth’s inner core sits at an average temperature of 9,900℉ ",
      "id":"5c14051ccacc0e23c5903dbe",
      "slideCount":13,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c3d02b7632c9b5857be3bd3",
      "title":"Da Vinci's Invention",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-14T21:44:23.102Z",
      "updatedAt":"2019-02-16T21:50:43.896Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"The Renaissance ManDa Vinci's Inventions Leonardo Da Vinci is considered the a Renaissance man, a person with many areas of interest. His passions included geology, geometry, astronomy, mathematics, botany, pyrotechnics, optics, and zoology. The “Leocopter,” or Air Screw, was to be powered by 4 men standing on a сentral platform turning cranks to rotate the shaft. One of Da Vinci's most famous inventions, the flying machine (also known as the \"ornithopter\") is clearly inspired by the flight of winged animals, which da Vinci hoped to replicate. The pilot would power the flying machine by pedaling a crank which would move the wings up and down. Da Vinci's self-propelled cart can be looked at as history's first car. The vehicle moved via a coiled spring.The cart even had programmable steering (although it could only turn right) which was locked in by rearranging wooden blocks within the gears. Power Mechanical engines were still a long way off in Da Vinci’s time. This machine was designed to be propelled using four men. They would stand on the central platform and turn large cranks.\n\n Da Vinci thought that if the screw was large enough it could lift the four men off the ground. The linen screw he designed was over 15 feet in diameter.  ",
      "id":"5c3d02b7632c9b5857be3bd3",
      "slideCount":9,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c3e437a632c9b5857be3be1",
      "title":"Fish",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-15T20:32:58.537Z",
      "updatedAt":"2019-02-16T21:49:51.920Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"FishAquatic Animals  ChimaeraChimaera were once an abundant group of fish that mostly went extinct millions of years ago.They are only found in very deep water and are rarely seen. LampreysLampreys belong to a class of fish called Petromyzons. They are a group of jawless fish with cartilage skeletons.They live in oceans except at spawning time when they migrate to freshwater. Ray Finned FishThe class Actinopterygii is also known as ray finned fish. These fish have fins that are attached by bony rays.﻿Ray finned fish also have a swim bladder which help them control their buoyancy.  Lobe Finned FishLobe finned fish are believed to be the ancestors of all four legged vertebrates. A very ancient group of animals, these fish still retain many ‘prehistoric’ characteristics today.  RaysRays are classified under a suborder of cartilaginous fish called batoids. Like sharks and chimaera they do not have a bony skeleton but have a skeleton made out of cartilage. There are over 630 species of rays and skates and they are easily distinguished from other fish species due to their unique features. SharksSharks are a group of cartilaginous fish. Like other cartilaginous fish they have five to seven gills located at the sides of their heads. There are over 400 species of sharks worldwide. ",
      "id":"5c3e437a632c9b5857be3be1",
      "slideCount":7,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c42be1c632c9b5857be3bec",
      "title":"Parthenon",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-19T06:05:16.787Z",
      "updatedAt":"2019-02-16T21:48:00.511Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "keywords":null,
      "textContent":"Type: TempleArchitectural style: ClassicalLocation: Athens, Greece PARTHENON The Greek word parthenon referred to the \"unmarried women's apartments\" in a house. In the case of the Parthenon, this seems to have been used at first for only a particular room in the temple. The Parthenon is a former temple located on the Athenian Acropolis and dedicated to the goddess Athena. The Greek goddess Athena was Athen's patron. She was the goddess of wisdom, warfare, and courage.﻿ Athena was sometimes given the epithet Hippia, referring to her invention of the bit, bridle, chariot, and wagon. Earlier the site had been a sacred place and a seat of other temples. The Parthenon replaced an older temple of Athena. The dimensions of the base of the Parthenon are 228 by 101 ft (69.5 by 30.9 m). The cella was 97.8 long by 63.0 ft wide (29.8 m by 19.2 m). ﻿ The Parthenon is an example of Doric order, which is a simple style with a plainer column than other styles of architecture. On the exterior, the Doric columns measure 6.2 ft (1.9 m) in diameter and are 34 ft (10.4 m) high. The corner columns are slightly larger in diameter. The Parthenon had 46 outer columns and 23 inner columns in total. Each column has 20 flutes. (A flute is the concave shaft carved into the column form.) Some of the sculptures from the Parthenon are on display at the Louvre in Paris and in Copenhagen, while the majority are in Athen's Acropolis Museum. ",
      "id":"5c42be1c632c9b5857be3bec",
      "slideCount":15,
      "labelsCount":1,
      "quizCount":4,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c46d85b632c9b5857be3bf6",
      "title":"Respiratory System",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-22T08:46:19.015Z",
      "updatedAt":"2019-02-16T21:46:50.661Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "keywords":null,
      "textContent":"The oxygen we breathe in goes into your lungs and then passes into your blood. From there it is then transported to all the cells in your body.  THE RESPIRATORY SYSTEM The respiratory system consists of the nose, throat, larynx, trachea, bronchi, and lungs. The trachea branches into two bronchi known as the left and right bronchus. Thyroid cartilage Bronchi Trachea These branches of the bronchi divide into smaller secondary bronchi (lobar bronchi). There are three in the right lung and two in the left lung. There is less space in the left lung because it shares space with the heart. The secondary bronchi branch into tertiary bronchi (segmental bronchi). The right lung is made up of ten areas known as bronchopulmonary segments. The left lung has nine of these segments.  Each bronchopulmonary segment has its own tertiary bronchus and its own branch of the pulmonary artery.  The airways inside the lungs keep branching into narrower airways until the air sacs (alveoli) are reached. The windpipe (trachea) and bronchi are lined with mucus-producing cells and many tiny hair-like projections termed cilia. The mucus traps foreign matter and the cilia carry the mucus out of your lungs and into your throat. As you breath in, air containing oxygen enters your trachea and passes through the bronchi to the alveoli. Gas exchange occurs in the alveoli. Each alveoli are surrounded by a network of fine blood vessels called capillaries.  The oxygen passes across the thin lining of the alveoli and into the blood vessels in a process known as diffusion. The oxygen is then carried around the body in the bloodstream. As oxygen passes into the bloodstream, carbon dioxide passes across the lining of the alveoli from the bloodstream to the alveoli. It then moves through the lungs and out the mouth and nose.  When you breath in, your chest and lungs expand. When you breathe out, your lungs get smaller. Both of these movements are caused by the diaphragm and intercostal muscles.  Adults breathe 14 to 16 times per minute. Approximately half a liter of air is inhaled in a normal breath.  ",
      "id":"5c46d85b632c9b5857be3bf6",
      "slideCount":11,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c483e1e1061ea6a2e3d7ea4",
      "title":"DNA - RNA",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{
         "0":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":0,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         },
         "5":{
            "dragStartPos":{
               "y":0,
               "x":0
            },
            "position":{
               "y":14.72,
               "x":40.08
            },
            "question":"Which are the macromolecules essential  for life?",
            "slide":5,
            "rightAnswer":"DNA, RNA and proteins",
            "meshes":[

            ],
            "answers":[
               "DNA, RNA and water",
               "DNA, RNA and Cells "
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         },
         "6":{
            "dragStartPos":{
               "y":0,
               "x":0
            },
            "position":{
               "y":2.01,
               "x":37.44
            },
            "question":"What is the function of the messenger RNA?",
            "slide":6,
            "rightAnswer":"Translate the DNA genetic code into protein.",
            "meshes":[

            ],
            "answers":[
               "It's basically the same as DNA",
               "Take the proteins from one place to another"
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         }
      },
      "createdAt":"2019-01-23T10:12:46.374Z",
      "updatedAt":"2019-02-16T20:56:43.076Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "keywords":null,
      "textContent":"﻿Is one of the three major biological macromolecules that are essential for all known forms of life (along with DNA and proteins).  ﻿RNA is the “DNA photocopy” of cells. When a cell needs to produce a certain protein, it activates the protein’s gene and produces multiple copies of that piece of DNA in the form of messenger RNA. The multiple copies of RNA are then used to translate the genetic code into protein. The flow of genetic information in a cell is from DNA through RNA to proteins. RIBONUCLEIC ACID (RNA) Ribonucleic acid\n\n(RNA) DNA The human genome contains 3 billions base pairs of DNA. A single cell can contain from 6 to 9 feet of DNA. 75 to 100 trillion is the amount of cells the humand body is composed of RIBONUCLEIC ACID (RNA) DNA The human genome contains 3 billions base pairs of DNA. A single cell can contain from 6 to 9 feet of DNA 75 to 100 trillion is the amount of cells the humand body is composed of Deoxyribonucleic Acid is the nucleic acid that instructions for organisms. Nucleotides are the chemical structures that make up DNA.\n\n\n\nA fast typist, working eight hours a day, would take\n 50 years to type out the human genome. RIBONUCLEIC ACID (RNA) DNA The human genome contains 3 billions base pairs of DNA. A single cell can contain from 6 to 9 feet of DNA 75 to 100 trillion is the amount of cells the humand body is composed of Deoxyribonucleic Acid is the nucleic acid that instructions for organisms. Nucleotides are the chemical structures that make up DNA.\n\n\n\nA fast typist, working eight hours a day, would take\n 50 years to type out the human genome. Most DNA molecules consist of two biopolymer strands coiled around each other to form a double helix.\n\nDNA is used by researchers as a molecular tool to explore physical laws and theories, such as the ergodic theorem and the theory of elasticity﻿﻿ RIBONUCLEIC ACID (RNA) DNA The human genome contains 3 billions base pairs of DNA. A single cell can contain from 6 to 9 feet of DNA 75 to 100 trillion is the amount of cells the humand body is composed of Deoxyribonucleic Acid is the nucleic acid that instructions for organisms. Nucleotides are the chemical structures that make up DNA.\n\n\n\nA fast typist, working eight hours a day, would take\n 50 years to type out the human genome. Most DNA molecules consist of two biopolymer strands coiled around each other to form a double helix.\n\nDNA is used by researchers as a molecular tool to explore physical laws and theories, such as the ergodic theorem and the theory of elasticity﻿﻿ The DNA backbone is resistant to cleavage, and both strands of the double-stranded structure store the same biological information. This information is replicated as and when the two strands separate. A large part of DNA (more than 98% for humans) is non-coding, meaning that these sections do not serve as patterns for protein sequences. RIBONUCLEIC ACID (RNA) DNA The human genome contains 3 billions base pairs of DNA. A single cell can contain from 6 to 9 feet of DNA 75 to 100 trillion is the amount of cells the humand body is composed of Deoxyribonucleic Acid is the nucleic acid that instructions for organisms. Nucleotides are the chemical structures that make up DNA.\n\n\n\nA fast typist, working eight hours a day, would take\n 50 years to type out the human genome. Most DNA molecules consist of two biopolymer strands coiled around each other to form a double helix.\n\nDNA is used by researchers as a molecular tool to explore physical laws and theories, such as the ergodic theorem and the theory of elasticity﻿﻿ The DNA backbone is resistant to cleavage, and both strands of the double-stranded structure store the same biological information. This information is replicated as and when the two strands separate. A large part of DNA (more than 98% for humans) is non-coding, meaning that these sections do not serve as patterns for protein sequences. The two strands of DNA run in opposite directions to each other and are thus antiparallel. RIBONUCLEIC ACID (RNA) DNA The human genome contains 3 billions base pairs of DNA. A single cell can contain from 6 to 9 feet of DNA 75 to 100 trillion is the amount of cells the humand body is composed of Deoxyribonucleic Acid is the nucleic acid that instructions for organisms. Nucleotides are the chemical structures that make up DNA.\n\n\n\nA fast typist, working eight hours a day, would take\n 50 years to type out the human genome. Most DNA molecules consist of two biopolymer strands coiled around each other to form a double helix.\n\nDNA is used by researchers as a molecular tool to explore physical laws and theories, such as the ergodic theorem and the theory of elasticity﻿﻿ The DNA backbone is resistant to cleavage, and both strands of the double-stranded structure store the same biological information. This information is replicated as and when the two strands separate. A large part of DNA (more than 98% for humans) is non-coding, meaning that these sections do not serve as patterns for protein sequences. The two strands of DNA run in opposite directions to each other and are thus antiparallel ",
      "id":"5c483e1e1061ea6a2e3d7ea4",
      "slideCount":13,
      "labelsCount":10,
      "quizCount":3,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c485ded1061ea6a2e3d7ea6",
      "title":"Zebras",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T12:28:29.377Z",
      "updatedAt":"2019-02-16T21:55:08.053Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "keywords":null,
      "textContent":"ZEBRASFamily name: EquidaeClassification: Mammal ﻿Zebras are social animals and live together in large groups, called herds.  Within a herd, zebras tend to stay together in smaller family groups, made up of a dominant male, several females (‘mares’) and their young (‘foals’). Our planet is home to three different species of zebra, all are native to Africa. Their most famous feature is their brilliant black-and-white striped coat, zebras have thick bodies, thin legs, a tufted tail, and a long head and neck sporting a short mane. Zebras can reach speeds of up to 40mph (65kph) when galloping across the plains. Their fierce fighting skills and strong social bonds help to protect zebras from predators (lions, leopards, hyenas and cheetahs). ",
      "id":"5c485ded1061ea6a2e3d7ea6",
      "slideCount":13,
      "labelsCount":1,
      "quizCount":6,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c6041061ea6a2e3d7ea8",
      "title":"Greek Warriors",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T19:52:36.584Z",
      "updatedAt":"2019-02-16T21:44:30.456Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"Battles of the Bronze AgeGreek Warriors During the Bronze Age, starting around 1600BC, the ancient Greeks fought in the heroic style of Homer. Ancient Greek warriors had already started to wear cumbersome, but effective, armor, and casualties were usually light during the melee. Men fought armed primarily with spears and short swords, and the Greek warriors had already jumped ahead of their contemporaries in the use of shields and armor. Fleeing enemies could not make use of their shields and made excellent targets. Aquiles was one of the greatest Greek warriors ",
      "id":"5c48c6041061ea6a2e3d7ea8",
      "slideCount":5,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c6551061ea6a2e3d7eac",
      "title":"Gutemberg Press",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T19:53:57.206Z",
      "updatedAt":"2019-02-16T21:13:43.160Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"Gutenberg PressThe history of printing The Gutenberg press was invented by German Johannes Gutenberg in 1440 and completely revolutionized the way text was made and distributed. Ink was rolled onto an ink ball and transferred onto the metal letters. Instead of creating wooden blocks for whole words or pages Gutenberg created metal blocks for each letter. The inspiration behind the press came from wine screw presses.  Each letter could be used over and over again as long as the carving remained sharp. Printers to rearrange the letters to suit their needs. ",
      "id":"5c48c6551061ea6a2e3d7eac",
      "slideCount":11,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c6601061ea6a2e3d7ead",
      "title":"Train",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T19:54:08.154Z",
      "updatedAt":"2019-02-16T21:17:18.563Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"Modes of TransportationTrain Trains were invented an astonishingly long time ago. The ancient Greeks were using a form of railway called ‘rutways’ in 600 BC. Trains are a mode of transport that run on specially built tracks. Carriages are able to be linked together to transport more passengers or goods. Trains run on rails, steel bars running along the ground. The wheels of the train are specially designed to straddle the tracks. Many trains are designed to carry passengers. The locomotive is the first part of a train. It contains the engine and is responsible for pulling the carriages. Sometimes two or more locomotives will be used for longer or heavier carriages. The idea was used for for at least 650 years before it was abandoned until at least the 1600s. Various small railways were used until the idea gained popularity in 1800.   The most common way to power locomotives is by burning diesel but electric trains are becoming far more common. ",
      "id":"5c48c6601061ea6a2e3d7ead",
      "slideCount":8,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c76f1061ea6a2e3d7ebb",
      "title":"Earth Seasons Moon Phases",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T19:58:39.781Z",
      "updatedAt":"2019-03-23T20:09:57.571Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":" For those of us who live in the Northern Hemisphere, where it’s summer in July and winter in January, that seems backwards, doesn’t it? That just goes to prove that Earth's distance from the Sun is not the cause of the seasons. Compared with how far away the sun is, this change in Earth's distance throughout the year does not make much difference to our weather. During part of the year, Earth is closer to the sun than at other times. However, in the Northern Hemisphere, we are having winter when Earth is closest to the sun and summer when it is farthest away There is a different reason for Earth's seasons. March In March, it is fall south of the equator and spring north of the equator. The Sun shines equally on the Southern and Northern Hemispheres. Earth's axis is an imaginary pole going right through the center of Earth from \"top\" to \"bottom.\" Earth spins around this pole, making one complete turn each day. That is why we have day and night, and why every part of Earth's surface experiences each one. Earth has seasons because its axis is not straight. June In June, it is winter south of the equator and summer north of the equator. The Sun shines directly on the Northern Hemisphere and indirectly on the Southern Hemisphere. It is summer in June in the Northern Hemisphere because the sun's rays hit that part of Earth more directly than at any other time of the year. As the Earth orbits the sun, its tilted axis always points in the same direction. Therefore, throughout the year, different parts of the Earth receives the sun’s direct rays. September In September, it is spring south of the equator and fall north of the equator. The Sun shines equally on the Southern and Northern Hemispheres. December In December, it is summer south of the equator and winter north of the equator. The Sun shines directly on the Southern Hemisphere and indirectly on the Northern Hemisphere The precise timing of the seasons is determined by the exact times of transit of the sun over the tropics of Cancer and Capricorn for the solstices and the times of the sun's transit over the equator for the equinoxes. A traditional date close to these times is used.﻿ Due to seasonal lag, June, July, and August are the warmest months in the Northern Hemisphere while December, January, and February are the warmest months in the Southern Hemisphere. The moon's endless dance As the Earth and moon orbit the sun together, the pattern of day and night on the lunar surface constantly changes. We refer to the percentage of illumination on the visible face of the moon as the moon's \"phase\". There are 8 major named phases that have been known throughout human history. WANING GIBBOUS THIRD QUARTER WANING CRESCENT  WAXING CRESCENT FIRST QUARTER WAXING GIBBOUS The moon rotates on its axis in about 27 days. Daytime on one side of the moon lasts about 13 and a half days, followed by 13 and a half nights of darkness. When sunlight hits the moon's surface, the temperature can reach 127°C and when the sun goes down, temperatures can dip to -173 °C. ﻿ One half of the moon's surface is always illuminated by the Sun's rays since it faces the Sun and the other is always dark. However, people on Earth see the illuminated half from different viewing geometries depending on the moon's angle to the earth during its rotation, which generates the moon's phases. The Moon is an astronomical body that orbits planet Earth and is Earth's only permanent natural satellite. It is the fifth-largest natural satellite in the Solar System, and the largest among planetary satellites relative to the size of the planet that it orbits (its primary). The Moon is the second-densest satellite in the Solar System, after Jupiter's satellite Io, among those whose densities are known.  What causes the seasons? It's all about Earth's tilt!\n Many people believe that the Earth is closer to the sun in the summer and that is why it is hotter. And, likewise, they think the Earth is farthest from the sun in the winter. Although this idea makes sense, it is incorrect.\n But what caused Earth to tilt? Long, long ago, when the Earth was young, it is thought that something big hit the Earth and knocked it off-kilter. Therefore, instead of rotating with its axis straight up and down, it leans over a bit. By the way, that big object that hit Earth is called Theia. It also blasted a big hole in the surface of the Earth. That big blast sent a huge amount of dust and rubble into orbit. Most scientists believe that that rubble, in time, became our Moon. Earth’s perihelion (the point closest to the Sun) = 91,400,000 miles from the Sun\n\n\n\nEarth’s aphelion (the point farthest from Sun) = 94,500,000 miles from the Sun While that is a difference of over 3 million miles, relative to the entire distance, it isn’t much.\n\n\nIt is true that Earth’s orbit is not a perfect circle. It is a bit lopsided. And, believe it or not, aphelion - when Earth is farthest from the Sun - occurs in July, and perihelion - when we are closest - occurs in January. ",
      "featured":false,
      "id":"5c48c76f1061ea6a2e3d7ebb",
      "slideCount":35,
      "labelsCount":3,
      "quizCount":4,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c7f41061ea6a2e3d7ebe",
      "title":"Spider Eratigena Atrica",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T20:00:52.875Z",
      "updatedAt":"2019-02-16T21:19:09.955Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"ERATIGENA ATRICA ﻿Class: ArachnidaOrder: Araneae The giant house spider is one of the biggest spiders of Central and Northern Europe. The bite of this species does not pose a threat to humans or pets, and it is generally reluctant to bite, preferring to escape. Its coloration is mainly dark brown. On its sternum is a lighter marking, with three light spots on each side. The opisthosoma features a lighter middle line with six \"spots\" on each side. They also have conspicuously hairy legs, palps and abdomen. The Giant House Spider eat common indoor pests, such as roaches, flies, earwigs, mosquitoes, and clothes moths. It have eight eyes, each with a single lens rather than multiple units as in the compound eyes of insects. The specific arrangement of the eyes is one of the features used in classifying different species Spiders, unlike insects, have only two main body parts (tagmata) instead of three: a fused head and thorax (called a cephalothorax) and an abdomen. The cephalothorax, also called prosoma, is composed of two primary surfaces: a dorsal carapace and a ventral sternum. Most external appendages on the spider are attached to the cephalothorax, including the eyes, chelicerae and other mouthparts, pedipalps and legs. It possesses venom to subdue its prey. Since E. atrica bites can penetrate human skin on occasion, the effects of agatoxin (toxins in the venom) might be felt by bite victims, though these spiders will not bite unless provoked. The female body size can reach 18.5 millimetres (0.73 in) in length, with males having a slightly smaller body at around 12 to 15 millimetres (0.47 to 0.59 in) in length. The abdomen is also known as the opisthosoma. On the ventral side of the abdomen are two hardened plates covering the book lungs. These are called the epigastric plates. A fold, known as the epigastric furrow, separates the region of the book lungs and epigyne from the more posterior part of the abdomen. The abdomen has no appendages except from the three modified pairs of movable telescoping organs called spinnerets, which produce silk. The female leg span is typically around 45 millimetres (1.8 in). The leg span of the male is highly variable, with spans between 25 to 75 millimetres (0.98 to 2.95 in) being common. With speeds clocked at 1.73 ft/s (0.53 m/s) (1.18 mph), the giant house spider held the Guinness Book of World Records for top spider speed until 1987 when it was displaced by solifugids. ",
      "id":"5c48c7f41061ea6a2e3d7ebe",
      "slideCount":14,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c85d1061ea6a2e3d7ec4",
      "title":"Molecules",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T20:02:37.576Z",
      "updatedAt":"2019-02-16T21:53:45.207Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"ChemistryIntroduction to Molecules A molecule is a group of atoms bonded together, representing the smallest fundamental unit of a chemical compound that can take part in a chemical reaction. They are so small that they are invisible to the naked eye. hydrogen hydrogen oxygen Salt Lattice - NaClis made up of Sodium and Chlorine ions. The unique chemical property of the ions align themselves into a uniform lattice shape. Salt Lattice - NaClis made up of Sodium and Chlorine ions. The unique chemical property of the ions align themselves into a uniform lattice shape. DNA - Deoxyribonucleic AcidThe building block that makes up our genetic material, is also a molecule!It has a very distinct double-helix shape, and is made up of two sugar-phosphate chains and a base-base rungs. adenine | thymine |cytosine | guanine Protein are molecules made up of a chain of amino acid folded into a unique shape. Molecules can also be man-made... Carbon Nanotubes are artificial molecules with a diameter of one-billionth of a meter. They are very strong and are valuable for many scientific applications. Water - H2OHere is a simple water molecule. It's made up of two hydrogen atoms and an oxygen atom. Water - H2OHere is a simple water molecule. It's made up of two hydrogen atoms and an oxygen atom. ",
      "id":"5c48c85d1061ea6a2e3d7ec4",
      "slideCount":12,
      "labelsCount":0,
      "quizCount":1,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c8db1061ea6a2e3d7ec5",
      "title":"Taj Mahal",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-23T20:04:43.011Z",
      "updatedAt":"2019-02-16T21:53:33.366Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":null,
      "textContent":"The Taj Mahal is an ivory-white marble mausoleum on the south bank of the Yamuna river in the Indian city of Agra built in the 1600s. The Taj Mahal was designated as a UNESCO World Heritage Site in 1983 for being \"the jewel of Muslim art in India and one of the universally admired masterpieces of the world's heritage\". The Taj Mahal was constructed using materials from all over India and Asia. It is believed over 1,000 elephants were used to transport building materials. The translucent white marble was brought from Makrana, Rajasthan.  The most spectacular feature is the marble dome that surmounts the tomb. The dome is nearly 35 metres. Because of its shape, the dome is often called an onion dome or amrud (guava dome). The top is decorated with a lotus design which also serves to accentuate its height. The main finial was originally made of gold but was replaced by a copy made of gilded bronze in the early 19th century. This feature provides a clear example of integration of traditional Persian and Hindu decorative elements. Today, the Taj Mahal receives more than 8 million visitors a year. It is regarded by many as the best example of Mughal architecture and a symbol of India's rich history. Location: Agra, Uttar Pradesh, India\nBuilt: 1632 - 1653\nArchitectural style: Mughal architecture\n TAJ MAHAL ",
      "id":"5c48c8db1061ea6a2e3d7ec5",
      "slideCount":12,
      "labelsCount":6,
      "quizCount":4,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c48c8ef1061ea6a2e3d7ec6",
      "title":"Tyrannosaurus Rex",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{
         "0":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":0,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         },
         "1":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":1,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         },
         "2":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":2,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         },
         "3":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"",
            "slide":3,
            "rightAnswer":"",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":0,
            "score":1,
            "required":false,
            "type":"radio",
            "name":"Question?",
            "active":false
         }
      },
      "createdAt":"2019-01-23T20:05:03.946Z",
      "updatedAt":"2019-02-16T21:32:01.809Z",
      "__v":0,
      "owner":"5c33eeea0ff75549015e549e",
      "keywords":"trex, t-rex, dinosaur",
      "textContent":"TYRANNOSAURUS REXFamily name:  TyrannosauroideaType: Tyrannosaurus Age: Cretaceous The name means “king of the tyrant lizards”: “tyranno” means tyrant and “saurus” means lizard in Greek. Whereas “rex” means king in Latin. Tyrannosaurus rex was one of the largest land carnivores of all time. It was a bipedal carnivore with a massive skull balanced by a long, heavy tail. The most complete specimen measures up to 40 ft (12.3 m) in length, up to 12 ft (3.66 m) tall at the hips. Like humans and birds of prey, T. rex had “binocular vision,” meaning its eyes looked directly forward and their planes of vision overlapped. Its jaws were strong enough to crush any animal, broken bones have been found in its dung. The question of whether Tyrannosaurus was an apex predator or a pure scavenger was among the longest ongoing debates in paleontology. The feeding habits, physiology and potential speed of Tyrannosaurus rex are a few subjects of debate. ",
      "id":"5c48c8ef1061ea6a2e3d7ec6",
      "slideCount":12,
      "labelsCount":2,
      "quizCount":3,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c4959481061ea6a2e3d7ed6",
      "title":"Steam Locomotive",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-01-24T06:20:56.332Z",
      "updatedAt":"2019-02-16T21:37:12.363Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "keywords":"train",
      "textContent":"A steam locomotive is a type of railway locomotive that produces its pulling power through a steam engine. These locomotives are fueled by burning combustible material – usually coal, wood, or oil – to produce steam in a boiler.  STEAM LOCOMOTIVE The steam moves reciprocating pistons which are mechanically connected to the locomotive's main wheels (drivers). Both fuel and water supplies are carried with the locomotive, either on the locomotive itself or in wagons (tenders) pulled behind. Steam locomotives were first developed in Great Britain during the early 19th century and used for railway transport until the middle of the 20th century. The first steam locomotive, made by Richard Trevithick, first operated on 21 February 1804, three years after the road locomotive he made in 1801.  The first commercially successful steam locomotive was created in 1812–13 by John Blenkinsop.[1] Built by George Stephenson and his son Robert's company Robert Stephenson and Company, the Locomotion No. 1 is the first steam locomotive to carry passengers on a public rail line, the Stockton and Darlington Railway in 1825.  George also built the first public inter-city railway line in the world to use locomotives, the Liverpool and Manchester Railway, which opened in 1830. Stephenson established his company as the pre-eminent builder of steam locomotives for railways in the United Kingdom, the United States, and much of Europe. The first commercially successful steam locomotive was created in 1812–13 by John Blenkinsop.[1] Built by George Stephenson and his son Robert's company Robert Stephenson and Company, the Locomotion No. 1 is the first steam locomotive to carry passengers on a public rail line, the Stockton and Darlington Railway in 1825.  George also built the first public inter-city railway line in the world to use locomotives, the Liverpool and Manchester Railway, which opened in 1830. Stephenson established his company as the pre-eminent builder of steam locomotives for railways in the United Kingdom, the United States, and much of Europe. From the early 1900s steam locomotives were gradually superseded by electric and diesel locomotives, with railways fully converting to electric and diesel power beginning in the late 1930s. The majority of steam locomotives were retired from regular service by the 1980s, though several continue to run on tourist and heritage lines. ",
      "id":"5c4959481061ea6a2e3d7ed6",
      "slideCount":5,
      "labelsCount":3,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c496c911061ea6a2e3d7edc",
      "title":"Locust",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "thumb":null,
      "slideQuizes":{
         "0":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"How is Locust social behaviour?",
            "slide":0,
            "rightAnswer":"Solitary",
            "answers":[
               "Lives in small family groups",
               "Lives in big hives",
               ""
            ],
            "timeLimit":10,
            "timeLimitEnabled":true,
            "score":1,
            "required":true,
            "type":"radio",
            "active":true
         },
         "1":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"If drought followed by rapid vegetation growth, serotonin in their brains triggers a dramatic set of changes: they start to breed abundantly, becoming gregarious and nomadic (loosely described as migratory) when their populations become dense enough. In this conditions they pose a major economic threat to agriculture.",
            "slide":1,
            "rightAnswer":"TRUE",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":10,
            "timeLimitEnabled":true,
            "score":1,
            "required":true,
            "type":"bool",
            "active":true
         },
         "2":{
            "position":{
               "y":0,
               "x":0
            },
            "question":"The adults are powerful ______; they can travel great distances, consuming most of the green vegetation wherever the swarm settles",
            "slide":2,
            "rightAnswer":"fliers",
            "answers":[
               "",
               "",
               ""
            ],
            "timeLimit":10,
            "timeLimitEnabled":true,
            "score":1,
            "required":true,
            "type":"text",
            "active":true
         }
      },
      "createdAt":"2019-01-24T07:43:13.211Z",
      "updatedAt":"2019-02-16T21:38:11.396Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "keywords":null,
      "textContent":"LOCUST ﻿﻿Are certain species of short-horned grasshoppers in the family Acrididae that have a swarming phase. These insects are usually solitary, but under certain circumstances they become more abundant and change their behaviour and habits, becoming gregarious. Under suitable conditions of drought followed by rapid vegetation growth, serotonin in their brains triggers a dramatic set of changes: they start to breed abundantly, becoming gregarious and nomadic  when their populations become dense enough. They form bands of wingless nymphs which later become swarms of winged adults. Both the bands and the swarms move around and rapidly strip fields and cause damage to crops Locusts consumes leaves and the tender tissues of plants. They are strong fliers as adults and tenacious hoppers as nymphs. Large swarms of locusts can completely strip the foliage and stems of plants such as forbs and grasses. No taxonomic distinction is made between locust and grasshopper species; the basis for the definition is whether a species forms swarms under intermittently suitable conditions. Swarming behaviour is a response to overcrowding. Increased tactile stimulation of the hind legs causes an increase in levels of serotonin. This causes the locust to change colour, eat much more, and breed much more easily. A large swarm can consist of billions of locusts spread out over an area of thousands of square kilometres, with a population of up to 80 million per square kilometre (200 million per square mile). By the early 20th century, efforts were being made to disrupt the development of the insects by cultivating the soil where eggs were laid, collecting hoppers with catching machines, killing them with flamethrowers, trapping them in ditches, and crushing them with rollers and other mechanical methods. In years when locust control is needed, the hoppers are targeted early by applying water-based, contact pesticides using tractor-based sprayers. This is effective but slow and labour-intensive, and where possible, spraying concentrated insecticide solutions from aircraft over the insects or the vegetation on which they feed is preferable. ",
      "id":"5c496c911061ea6a2e3d7edc",
      "slideCount":9,
      "labelsCount":1,
      "quizCount":1,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c59b2548511c52471f8c10c",
      "title":"Stonehenge",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "keywords":null,
      "textContent":"STONEHENGE Location  Wiltshire, England\nType         Monument Archaeologists believe it was constructed from 3000 BC to 2000 BC. The surrounding circular earth bank and ditch, which constitute the earliest phase of the monument, have been dated to about 3100 BC. Radiocarbon dating suggests that the first bluestones were raised between 2400 and 2200 BC STONE TYPES There are two main materials of stones, sarsen and blue stone. Sarsen is a type of sandstone that is common in the region. It represent the principal building material used in the monument’s construction, of which 53 stones remain, from around 85 in the original structure Bluestone Sarsen  The smaller stones are known as bluestones. While they’re not all that blue, they appear to have a slight bluish tint when they’re wet. MYSTERY It's a mystery how they got there! It is believed that many of the stones had to dragged more than 155 miles (250 km) to reach the site's location. There are three main theories as to the purpose of the prehistoric monument.1. It was a site of religious worship and ritual.2. It was an elaborate burial site.3. It was a giant observatory/astronomical clock. ",
      "thumb":null,
      "slideQuizes":{
         "9":{
            "dragStartPos":{
               "y":37.0048,
               "x":682.9504
            },
            "position":{
               "y":4.34,
               "x":38.47
            },
            "question":"Stonehenge is in:",
            "slide":9,
            "rightAnswer":"Wiltshire, England",
            "meshes":[

            ],
            "answers":[
               "Cork, Ireland",
               "Tottenham, England"
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         },
         "10":{
            "position":{
               "y":58.16,
               "x":41.69
            },
            "question":"Stonehenge is a monument of:",
            "slide":10,
            "rightAnswer":"Prehistory",
            "meshes":[

            ],
            "answers":[
               "Middle Ages",
               "War"
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         },
         "11":{
            "dragStartPos":{
               "y":45.9728,
               "x":1068.0256
            },
            "position":{
               "y":4.66,
               "x":40.6
            },
            "question":"When it is estimated that it was built?",
            "slide":11,
            "rightAnswer":"3000 BC to 2000 BC.",
            "meshes":[

            ],
            "answers":[
               "1000 BC to 100 BC.",
               "7000 BC to 5000 BC."
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         },
         "12":{
            "dragStartPos":{
               "y":0,
               "x":0
            },
            "position":{
               "y":1.17,
               "x":36.24
            },
            "question":"It is not a stone type found in Stonehenge",
            "slide":12,
            "rightAnswer":"Syenite",
            "meshes":[

            ],
            "answers":[
               "Sarsen",
               "Bluestone"
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         },
         "13":{
            "dragStartPos":{
               "y":0,
               "x":0
            },
            "position":{
               "y":2.44,
               "x":39.33
            },
            "question":"The giant three-piece arches for which Stonehenge is known, are called:",
            "slide":13,
            "rightAnswer":"Trilithons.",
            "meshes":[

            ],
            "answers":[
               "preeminent archs.",
               "Billithons."
            ],
            "timeLimit":0,
            "timeLimitEnabled":false,
            "userScore":0,
            "score":1,
            "required":false,
            "type":"radio",
            "active":true
         }
      },
      "createdAt":"2019-02-05T15:57:08.590Z",
      "updatedAt":"2019-02-19T18:21:45.016Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "id":"5c59b2548511c52471f8c10c",
      "slideCount":10,
      "labelsCount":1,
      "quizCount":3,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c6966e10f105e3692bc184d",
      "title":"Neurons",
      "categories":[
         {
            "_id":"5b2ea1ebd8d14668ba1c5ce5",
            "name":"Curricular Content",
            "slug":"curricular-content",
            "enabled":true,
            "createdAt":"2018-06-23T19:39:23.139Z",
            "updatedAt":"2018-06-27T13:19:22.813Z",
            "__v":0,
            "id":"5b2ea1ebd8d14668ba1c5ce5",
            "only_google":true
         },
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":"Placeholder description",
      "keywords":null,
      "textContent":"The central nervous system is the communication highway for the body.This system is one of the first to develop in the womb and is ultimately controlled by the brain. The spinal cord is one of the integral parts of the central nervous system.The spinal cord is a long bundle of nerves which directly connect to the brain.\n\nThese nerves are protected by 33 vertebral bones. The nerves in the spinal cord send and receive messages from around the body, often in response to external stimuli. Spinal nerves attach to the spinal cord and relay information to and from the body’s appendagesStimuli - something that causes a functional reaction to organs and tissues. For example the sensation of water hitting the skin. The brain contains 100 billion nerve cells.There are many types of nerve cells located in the brain (possibly hundreds) and researchers are currently learning what each type does.The brain is the processing center of all electrical and chemical impulses created as a result of both internal and external stimuli. DNA stands for deoxyribonucleic acid and is found tightly coiled within the cell nucleus. The average length of a strand of DNA within humans measures between five and six feet long. DNA is able to self replicate and carries all the genetic information needed to create the organism (in this case, human) Genetic information is stored as a code consisting of four chemical basesApproximately 3 billion base pairs are found in each strand of DNA in the human body.These base pairs dictate a wide range of traits; from eye color, to height and even predispositions to diseases such as breast cancer.Bases always pair in the same way  A - T,  C - G  Enter Your Text The soma contains the main cell body, including all its genetic information See inside the cell! Also located within the soma of the nerve cell are mitochondria.Mitochondria act as the digestive system of the cell, taking organic molecules and breaking them down.  Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Enter Your Text Neurons are irreplaceable nerve cells located in clusters called ganglia throughout the central nervous system. The largest of these cells are located in your leg, these can be over three feet long! Dendrites are extensions of the neuron cell that branch out from the soma.Each single neuron can have up to 2,000 connections to other neurons via the dendrites.They recieve chemical and electric signals from other nerve cells and transmit the information to the soma. The soma contains the main cell body, including all its genetic information See inside the cell! Neurons are irreplaceable nerve cells located in clusters called ganglia throughout the central nervous system. The largest of these cells are located in your leg, these can be over three feet long! Neurons are irreplaceable nerve cells located in clusters called ganglia throughout the central nervous system. The largest of these cells are located in your leg, these can be over three feet long! Dendrites are extensions of the neuron cell that branch out from the soma. They recieve chemical and electric signals from other nerve cells and transmit the information to the soma. Each single neuron can have up to 2,000 connections to other neurons via the dendrites.  Axons transmit electrochemical signals away from the soma to other neurons.The axon is the long tail like fibre that runs down the neuron.  Neurons are irreplaceable nerve cells located in clusters called ganglia throughout the central nervous system. The largest of these cells are located in your leg, these can be over three feet long! Dendrites are extensions of the neuron cell that branch out from the soma. They recieve chemical and electric signals from other nerve cells and transmit the information to the soma. Each single neuron can have up to 2,000 connections to other neurons via the dendrites.  The axon is the long tail like fibre that runs down the neuron.  Axons transmit electrochemical signals away from the soma to other neurons. The myelin sheath is a fatty layer of tissue that surrounds the axon. If the myelin sheath becomes damaged nerve cells become slower. In diseases such as multiple sclerosis immune cells attack the myelin sheath, mistaking it for a foreign object. Slide transition - zooms back out to this level before zooming back in, transitioning to mitochondria object  The largest of these cells are located in your leg, these can be over three feet long!The soma contains the main cell body, including all its genetic informationNeurons are irreplaceable nerve cells located in clusters called ganglia throughout the central nervous system.The nucleus contains the genetic information of the organism. Unlike many other types of cells however neurons are unable to reproduce. Carbohydrate molecules are one of the few molecules that can pass through the nuclear pores. Other, larger and more complex molecules need to be recognized by the nucleus before they are able to enter. Carbohydrate molecules are one of the few molecules that can pass through the nuclear pores. Other, larger and more complex molecules need to be recognized by the nucleus before they are able to enter. Approximately 3 billion base pairs are found in each strand of DNA in the human body. These base pairs dictate a wide range of traits; from eye color, to height and even predispositions to diseases such as breast cancer. Bases always pair in the same way  A - T, C - G\n The hydrogen bond is weak, allowing easy separation during DNA replication.\n\n\nEach base pair is connected using a hydrogen bond. Within the soma is all the eukaryotic cell organelles such as the nucleus.The nucleus envelope is unique in eukaryotic cells. It encases the genetic material, keeping it contained and protected.The nucleus contains the genetic information of the organism. Unlike many other types of cells however neurons are unable to reproduce. Carbohydrate molecules are one of the few molecules that can pass through the nuclear pores.Other, larger and more complex molecules need to be recognized by the nucleus before they are able to enter. Neurons have a very high metabolic rate and require a huge supply of oxygen and glucose compared to other cells within the body. The brain consumes up to a quarter of all calories ingested daily.\n\n\nMitochondria utilize oxygen and glucose to produce energy. \n\n Within the soma is all the eukaryotic cell organelles such as the nucleus. The nucleus envelope is unique in eukaryotic cells. It encases the genetic material, keeping it contained and protected. The nucleus contains the genetic information of the organism. Unlike many other types of cells however neurons are unable to reproduce. Rough endoplasmic reticulum surrounds the nucleus. Rough ER synthesize protein molecules.Within the soma is all the eukaryotic cell organelles such as the nucleus.There are approximately 2,000 nuclear pores on each nucleus. Within the soma is all the eukaryotic cell organelles such as the nucleus. The nucleus envelope is unique in eukaryotic cells. It encases the genetic material, keeping it contained and protected. The nucleus contains the genetic information of the organism. Unlike many other types of cells however neurons are unable to reproduce. Rough endoplasmic reticulum surrounds the nucleus. Rough ER synthesize protein molecules. Within the soma is all the eukaryotic cell organelles such as the nucleus. There are approximately 2,000 nuclear pores on each nucleus. ",
      "thumb":null,
      "slideQuizes":null,
      "createdAt":"2019-02-17T13:51:29.733Z",
      "updatedAt":"2019-03-05T11:56:37.813Z",
      "__v":0,
      "owner":"5b633cbf4feebd45d3d7aedc",
      "id":"5c6966e10f105e3692bc184d",
      "slideCount":14,
      "labelsCount":1,
      "quizCount":1,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5c6f9a898411716badd094f6",
      "title":"Bench drill",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "tags":[

      ],
      "description":null,
      "keywords":null,
      "textContent":"Table height adjustment Base Handle Column Table Belt and Pulley cover Quill Power Chuck Table height adjustment Table height adjustment Table height adjustment Table height adjustment Table height adjustment Table height adjustment ",
      "thumb":null,
      "slideQuizes":{

      },
      "createdAt":"2019-02-22T06:45:29.908Z",
      "updatedAt":"2019-03-23T20:10:17.712Z",
      "__v":0,
      "owner":"5b3fa3d7bfe27a76152292b2",
      "id":"5c6f9a898411716badd094f6",
      "featured":false,
      "slideCount":2,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   },
   {
      "_id":"5a65231dde30ecf6472ec27c",
      "uuid":"bc48a3ee-37e3-4f4c-bdcc-033f2c3aa418",
      "username":"Elbriga",
      "title":"Teeth",
      "subtitle":"Test Subtitle",
      "ratio":"16:9",
      "views":54,
      "dateAdded":"2018-01-21T23:32:45.053Z",
      "dateModified":"2018-01-22T00:20:30.921Z",
      "__v":0,
      "description":null,
      "keywords":"",
      "slideQuizes":{

      },
      "textContent":"Human AnatomyTeeth The human teeth function to mechanically break down items of food by cutting and crushing them in preparation for swallowing and digesting. Tooth development or odontogenesis is the complex process by which tooth form from embryonic cells, grow, and erupt into the mouth. Humans have four types of teeth: incisors, canines, premolars, and molars, each with a specific function. The incisors cut the food, the canines tear the food and the molars and premolars crush the food. The roots of teeth are embedded in the maxilla (upper jaw) or the mandible (lower jaw) and are covered by gums. ",
      "thumb":null,
      "updatedAt":"2019-02-16T21:55:38.560Z",
      "categories":[
         {
            "_id":"5c34485e840bf753415df684",
            "name":"Demo",
            "slug":"demo",
            "enabled":true,
            "createdAt":"2019-01-08T06:51:10.317Z",
            "updatedAt":"2019-02-17T00:15:53.295Z",
            "__v":0,
            "id":"5c34485e840bf753415df684"
         }
      ],
      "id":"5a65231dde30ecf6472ec27c",
      "tags":[

      ],
      "slideCount":6,
      "labelsCount":0,
      "quizCount":0,
      "classes":[

      ],
      "results":[

      ]
   }
],
        category: {}
      }
    },
    mounted: function () {
        this.$store.state.libLoading = true;

        this.axios.get(this.$store.state.API_URL+'category?name='+this.$route.params.name)
        .then((res) => {
            this.category = res.data;

          this.axios.post(this.$store.state.API_URL + 'demo/filter', {
            filters: {category: [{name: res.data[0].name, id: res.data[0].id}]},
          }).then((res) => {
            // this.myDemos = res.data;
            this.$store.state.libLoading = false;
          });
        });
    },
    methods: {
      deleteTour(tour) {
        console.log('NO!');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/SecretLibrary.vue